import React from 'react';
import { HeaderLink } from '../../interfaces';
import Link from 'next/link';

export const BarItemMolecule = (props: HeaderLink) => {
  const newTab = props.newTab ? '_blank' : '_self';
  return (
    <li
      data-cy="bar-item"
      key={`${props.href}${props.label}`}
      className="text-center inline-block first:pl-0 px-5 last:pr-0 uppercase whitespace-nowrap font-medium"
    >
      <Link href={props.href}>
        <a className="no-underline" target={newTab}>
          <span>{props.label}</span>
        </a>
      </Link>
    </li>
  );
};
